module.exports = "/_next/static/images/video_id_7124390940063698222-eff8e16be58c9382c491cc95fa823233.jpg";